// var base_url = "http://127.0.0.1:55555/api/v1" 
var base_url = window.location.origin+"/api/v1" 
export default base_url
